import { useState } from 'react';
import { getApiErrorMessage } from '@/api/axios';
import { createPayment } from '@/api/payment.api';
import type { PaymentCreatePayload, PaymentCreateResponse } from '@/api/types';

export function useCreatePayment() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (
    payload: PaymentCreatePayload,
  ): Promise<PaymentCreateResponse> => {
    setLoading(true);
    setError(null);

    try {
      const res = await createPayment(payload);
      return res.data;
    } catch (error) {
      setError(getApiErrorMessage(error, 'Payment failed'));
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { submit, loading, error };
}
